import debugConfig from './debug.config';

// tslint:disable: no-console
if (debugConfig.showTrackingLogs) {
  console.group();
  console.info('*** GA Tracking ID *** ', process.env.REACT_APP_GA_ID);
  console.info('*** Rybbit Site ID *** ', process.env.REACT_APP_RYBBIT_SITE_ID);
  console.groupEnd();
}

/**
 * Rybbit — self-hosted product analytics, replacing Amplitude.
 *
 * Site 3 is the Partner site. Partner, admin and the tenant apps are separate
 * Rybbit sites on purpose: a partner is not a tenant and not an ops user, so
 * merging them would make user counts, retention and every funnel meaningless.
 *
 * No default id. Amplitude's key had a hardcoded fallback, so a misconfigured
 * environment wrote silently into the production project.
 */
export const TRACKING_RYBBIT_HOST =
  process.env.REACT_APP_RYBBIT_HOST || 'https://analytics.birdnestlife.com';

export const TRACKING_RYBBIT_SITE_ID = process.env.REACT_APP_RYBBIT_SITE_ID || '';

export enum ConversionEvents {
  addPaymentInfo = 'addPaymentInfo',
  search = 'search',
  addToCart = 'addToCart',
  completeRegister = 'completeRegister',
  purchase = 'purchase',
  customizeProduct = 'customizeProduct',
  lead = 'lead',
  initiateCheckout = 'initiateCheckout'
}

export enum FirebaseConversions {
  addPaymentInfo = 'add_payment_info',
  addToCart = 'add_to_cart',
  completeRegister = 'complete_registration',
  customizeProduct = 'select_item',
  lead = 'lead',
  search = 'search',
  purchase = 'purchase',
  initiateCheckout = 'checkout'
}

export enum FacebookConversions {
  addPaymentInfo = 'AddPaymentInfo',
  addToCart = 'AddToCart',
  completeRegister = 'CompleteRegistration',
  customizeProduct = 'CustomizeProduct',
  purchase = 'Purchase',
  lead = 'Lead',
  search = 'Search',
  initiateCheckout = 'InitiateCheckout'
}

export const SURVEY_MODULE_TRACKING = {
  SUB_VIEWS: {
    SURVEY_NOT_FOUND: '/survey/not-found',
    SURVEY_TAKEN: '/survey/survey-taken',
    SURVEY_SUCCESS: '/survey/success'
  },
  EVENTS: {
    START_SUCCESS_SURVEY: 'explore-button-survey-start',
    EXPLORE_NOT_FOUND_SURVEY: 'explore-button-survey-not-found',
    EXPLORE_TAKEN_SURVEY: 'explore-button-survey-taken'
  }
};
